export default __webpack_public_path__ + "static/media/logo_login.8bc432d2.png";